import { Component, OnInit } from '@angular/core';
import { ApiService, CacheService } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../../services/loader.service';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';

@Component({
    selector: 'ez-language',
    template: require('./language.component.html'),
    styles: [require('./language.component.less')]
})
export class LanguageComponent {
    public locales: Array<any>;
    public localeId: number = null;

    constructor(
        private apiService: ApiService,
        private translateService: TranslateService,
        private loaderService: LoaderService
    ) {
        let subs: Array<Observable<any>> = [];
        this.loaderService.show();

        let miscConfig = this.apiService.miscConfig();
        miscConfig.subscribe((res) => {
            this.locales = res.locales;
        });
        subs.push(miscConfig);

        let session = this.apiService.user();
        session.subscribe((user) => {
            this.localeId = user.localeId;
        });
        subs.push(session);

        Observable.forkJoin(subs).subscribe(
            res => {
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public save() {
        this.loaderService.show();

        // save the user language in database
        this.apiService.saveUserLocale(this.localeId).subscribe(
            (res) => {
                if (res.updated === true) {
                    let newLocale = res.locale;
                    localStorage.setItem('locale', newLocale.code);
                    moment.locale(newLocale.code);
                    this.translateService.use(newLocale.code);
                    // refresh misc config with new local
                    CacheService.remove(CacheService.MISC_CONFIG);
                    this.apiService.miscConfig().subscribe();
                }
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/language/language.component.ts